import { useState, useEffect, useRef, useContext } from 'react';
import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import Footer from "../sub-components/Footer.tsx";
// import PageInput from '../sub-components/PageInput';
import OrderedDataTable from '../sub-components/OrderedDataTableCopy.jsx';
import PageContext from '../sub-components/PageContext';
import standardSearch from '../functions/standardSearch';
import applyFilters from '../functions/applyFilters';
import { HttpContext } from '../../api-services/HttpService';
import { Link } from 'react-router-dom';
import SubCompanySearchRow from '../sub-components/SubCompanySearchRow'; 
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from 'redux';
import { actionCreators } from "../../redux/index";
import PageInputRedux from '../sub-components/PageInputReduxTooltopCopy.jsx';
import PageBreadcrumbs from '../sub-components/PageBreadcrumbs.jsx'; 
import ButtonComponent from '../sub-components/ButtonComponent.jsx';
import PageDropdownRedux from '../sub-components/PageDropdownReduxCopy.jsx'; 
import standardFilter from '../functions/standardFilter.js';

const SubCompanySearchPage = () => {
    // initialize http context 
    const {
        GET, 
    } = useContext(HttpContext);
    // initialize redux persisent state for search 
    const subCompanySearch = useSelector((state) => state.subCompanySearch);
    const companyTypeFilter3 = useSelector((state) => state.companyTypeFilter3); 
    const rebatePortfolio3 = useSelector((state) => state.rebatePortfolio3); 
    const dispatch = useDispatch();
    const { 
        setSubCompanySearch, 
        setCompanyTypeFilter3, 
        setRebatePortfolio3
    } = bindActionCreators(actionCreators, dispatch);
    // initialize state variables
    // const [searchValue, setSearchValue] = useState(''); 
    const [showSpinner, setShowSpinner] = useState(false); 
    // initialize state for filter lists
    const [companyTypeList, setCompanyTypeList] = useState(['All']); 
    const [rebatePortfolioList, setRebatePortfolioList] = useState(['All']); 
    // initialize state variables for table
    const [dataList, setDataList] = useState([]); 
    const [showDataList, setShowDataList] = useState([]); 
    const [tableHeader, setTableHeader] = useState([]); 
    const [enableReset, setEnableReset] = useState(false);

    // initialize useRef to determine initial render
    const initialRender = useRef(false); 

    // function wrapper to pass row component to datatable
    const RowComponent = (row, count, tableHeader,stickyFirstColumnEnabled,index,selectableRows) =>{
        return(
            <>
                <SubCompanySearchRow row={row} count={count} tableHeader={tableHeader} selectableRows={selectableRows}/>
            </>
        ); 
    }  

    // promise to fetch sub company data 
    const getSubCompanyData = () => {
        // show spinner while fetching data
        setShowSpinner(showSpinner => showSpinner = true); 
        // use GET function to fetch data 
        return new Promise((resolve, reject) => {
            GET('/data/subCompanySearchPage', {}).then(res => {
                // set state variables 
                setTableHeader(tableHeader => tableHeader = res['data']['SubCompanySearchTableHeader']); 
                setDataList(dataList => dataList = res['data']['SubCompanySearchDataList']); 
                setShowDataList(showDataList => showDataList = res['data']['SubCompanySearchDataList']); 
                // set filter state 
                setCompanyTypeList(companyTypeList => companyTypeList = ['All', ...res['data']['CompanyTypeList']]); 
                setRebatePortfolioList(rebatePortfolioList => rebatePortfolioList = ['All', ...res['data']['PortfolioList']]);
                // hide spinner 
                setShowSpinner(showSpinner => showSpinner = false); 
                // resolve on success
                resolve(res); 
            }).catch(err => {
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false); 
                // reject on error
                reject(err); 
            }); 
        }); 
    }

    // useEffect to run on initial render 
    useEffect(() => {
        getSubCompanyData().then(res => {
            console.log(res); 
        }).catch(err => {
            console.log(err); 
        }); 
    }, []); 

    // useEffect to run list of search/filter functions on table data
    useEffect(() => { 
        // do not run on initial render
        if (!initialRender.current){
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: standardSearch, value: subCompanySearch, flag: 0, cols: ['companyname', 'companyid', 'mastercompanyid', 'primaryccrm']}, 
                {function: standardFilter, value: companyTypeFilter3, flag: 1, cols: ['companytypedescription']}, 
                {function: standardFilter, value: rebatePortfolio3, flag: 1, cols: ['incentivetype']}
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(dataList, functionList);
            // update showDataList
            setShowDataList(showDataList => showDataList = filteredList);
        }
        else{
            initialRender.current = false;
        }
        
    }, [dataList, subCompanySearch, companyTypeFilter3, rebatePortfolio3]);


    // state variables to pass to page context 
    const settings ={

    }

    //reset functionality 
    const resetToDefault = () => {
        setSubCompanySearch('');
        setCompanyTypeFilter3(companyTypeList[0]); 
        setRebatePortfolio3(rebatePortfolioList[0]); 
    }

    const enableResetAll = () => {
        if(subCompanySearch !== '' || companyTypeFilter3 !== companyTypeList[0] || rebatePortfolio3 !== rebatePortfolioList[0]
        ){
            return true;
        }
        return false;
    }

    useEffect(() => {
        if(enableResetAll()){
            setEnableReset(true);
        } else {
            setEnableReset(false);
        }
    }, [subCompanySearch, companyTypeFilter3, rebatePortfolio3 ])
    
    return(
        <div class='summary-page'>
            {/* wrap children so they can access variables in PageContext */}
            <PageContext.Provider value={ settings }>
                {/* header and navslider present on every page */}
                <HeaderBanner />
                {/* breadcrumbs */}
                <div className="pt-1 ps-3 ms-3">
                    <PageBreadcrumbs />
                </div>
                <div className="container-fluid d-flex flex-column">
                    <div className="d-flex flex-column flex-grow-1 p-2">
                        {/* label for search column dropdown and search bar */}
                        <div className="mb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <div className='d-flex justify-content-between flex-wrap p-3'>
                                <div className='d-flex'>
                                    <div className='align-self-center'>Search By</div>
                                    <div>
                                        <Link
                                            to={{
                                                pathname: "/CompanyProfilePage",
                                            }}
                                        >
                                            <ButtonComponent
                                                tag={process.env.REACT_APP_MASTER_COMPANY_ID_TAG}
                                                border={'#000 1px solid'}
                                                background={window.location.pathname === '/CompanyProfilePage' ? '#000' : '#fff'}
                                                color={window.location.pathname === '/CompanyProfilePage' ? '#fff' : '#001317'}
                                                width={'120px'}
                                            />
                                        </Link>
                                    </div>
                                    <div>
                                        <Link
                                            to={{
                                                pathname: "/SubCompanySearchPage",
                                            }}
                                        >
                                            <ButtonComponent
                                                tag={"Company"}
                                                border={'#000 1px solid'}
                                                background={window.location.pathname === '/SubCompanySearchPage' ? '#000' : '#fff'}
                                                color={window.location.pathname === '/SubCompanySearchPage' ? '#fff' : '#001317'}
                                                width={'120px'}
                                            />
                                        </Link>
                                    </div>
                                    <div>
                                        <Link
                                            to={{
                                                pathname: "/ConsortiumSearchPage",
                                            }}
                                        >
                                            <ButtonComponent
                                                tag={"Consortium"}
                                                border={'#000 1px solid'}
                                                background={window.location.pathname === '/ConsortiumSearchPage' ? '#000' : '#fff'}
                                                color={window.location.pathname === '/ConsortiumSearchPage' ? '#fff' : '#001317'}
                                                width={'120px'}
                                            />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <hr style={{ margin: 0 }}/>
                            <div className='d-flex p-3'>
                            <div className= "pe-3">
                                    <PageDropdownRedux tag='Company Type' value={companyTypeFilter3} setValue={setCompanyTypeFilter3} list={companyTypeList} />
                                </div>   
                                <div className= "pe-3">
                                    <PageDropdownRedux tag='Portfolio' value={rebatePortfolio3} setValue={setRebatePortfolio3} list={rebatePortfolioList} />
                                </div>   
                                <div className='pe-2 align-self-center'>
                                    Search Company by
                                </div>
                                <div className= "pe-3">
                                    <PageInputRedux tag='' value={subCompanySearch} setValue={setSubCompanySearch} />
                                </div>
                                <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${enableReset ? '#0295BE': '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => enableReset ? resetToDefault(): null}>
                                        Reset All
                                </div>
                            </div>

                        </div>
                        {/* table to display company data with links for drilldown */}
                        <div className="flex-grow-1" style={{ borderRadius: '12px', background: '#fff' }}>
                            <OrderedDataTable RowComponent={RowComponent} tableHeader={tableHeader} dataList={showDataList} showSpinner={showSpinner} numToPage={50} skeletonHeight='28vh'
                                sortingEnabled={true} stickyFirstColumnEnabled={false} selectableRows/>
                        </div>
                    </div>
                </div>
                <Footer cssClassName="footer-main-comp"/>
            </PageContext.Provider>
        </div>
    ); 
}

export default SubCompanySearchPage; 